/* eslint-disable no-unused-vars */
import { toast } from 'react-toastify';
import InformationSignalrService from '../../services/signalR/InformationSignalrService';
import { signalREventNames } from '../../constants/enums';
// import { getCurrentWorkperiod } from "../pos/posSlice";
import { setCurrentLoginInformation } from '../auth/authSlice';

const signalRMiddleware = (store) => (next) => (action) => {
  if (action.type === setCurrentLoginInformation.type) {
    const connection = InformationSignalrService.init();

    connection.on(signalREventNames.WorkPeriodUpdated, (message) => {
      toast.success(message);
      // store.dispatch(getCurrentWorkperiod());
    });

    connection.on(signalREventNames.Message, (message) => {
      toast.info(message);
    });
  }

  return next(action);
};

export default signalRMiddleware;
